import React, { useState, useEffect, useRef } from 'react';
import systemInsightsLogo from '../../assets/images/SystemInsights.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [navBackground, setNavBackground] = useState(false);
  const menuRef = useRef(null);

  const handleScroll = () => {
    const scroll = window.scrollY;
    if (scroll > 0) {
      setNavBackground(true);
    } else {
      setNavBackground(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1024) {
      if (isOpen) {
        menuRef.current.style.height = menuRef.current.scrollHeight + 'px';
      } else {
        menuRef.current.style.height = '0px';
      }
    } else {
      menuRef.current.style.height = 'auto';
    }
  }, [isOpen]);

  return (
    <nav
      className={`py-0 px-0 backdrop-blur-md lg:transition-all lg:duration-500 fixed top-0 left-0 w-full z-[1030] shadow-md ${
        navBackground ? 'bg-white shadow-md' : 'bg-white/80'
      }`}
      id="navbar"
    >
      <div className="lg:px-10 px-8 w-full">
        {/* Desktop: logo left-justified, links absolutely centered on full width */}
        <div className="hidden lg:block relative w-full">
          <a className="inline-flex items-center relative z-10" href="#home">
            <img src={systemInsightsLogo} className="h-24" alt="System Insights" />
          </a>
          <div className="absolute inset-0 flex items-center justify-center">
            <ul className="flex items-center gap-x-12">
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-base font-medium capitalize" href="#home">Home</a>
              </li>
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-base font-medium capitalize" href="#features">AI Tools</a>
              </li>
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-base font-medium capitalize" href="#platforms">Platforms</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Mobile */}
        <div className="flex flex-wrap items-center lg:hidden">
          <a className="flex items-center shrink-0" href="#home">
            <img src={systemInsightsLogo} className="h-16" alt="System Insights" />
          </a>
          <div className="flex items-center ms-auto px-2.5">
            <button
              className="text-gray-700 p-2"
              type="button"
              onClick={() => setIsOpen(!isOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
          <div
            className="basis-full overflow-hidden"
            id="navbarCollapse"
            ref={menuRef}
          >
            <ul className="flex flex-col gap-y-2 py-4">
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-sm font-medium capitalize" href="#home">Home</a>
              </li>
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-sm font-medium capitalize" href="#features">AI Tools</a>
              </li>
              <li className="text-gray-600 hover:text-darkblue transition-all duration-500">
                <a className="text-sm font-medium capitalize" href="#platforms">Platforms</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
